<template>
  <van-popup
    class="popup_box"
    v-model:show="showValue"
    round
    :style="{ padding: '64px' }"
    @click-overlay="onClose"
    :transition-appear="true"
    transition="scaleIn"
  >
    <div @click="onClose" class="popup_close close_center"><span></span></div>
    <div class="popup">
      <h1>Choose a country</h1>
      <div class="popup_nation">
        <div @click="onSelect(item)" v-for="(item, index) in countries" :key="index">
          <li :class="countries[country].phone == item.phone ? 'popup_nation_active' : ''">
            <img :src="`${item.icon}`" />
            <p>(+{{ item.phone }})&nbsp;&nbsp;&nbsp;&nbsp;{{ item.name }}</p>
            <p>{{ item.text }}</p>
            <i class="bi bi-check"></i>
          </li>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { useUserStore } from '@/stores/user'
import { BUS, POPUP } from '@/event/EventCenter'
export default {
  name: 'LobbySelectCountry',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    from: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showValue: false
    }
  },
  watch: {
    show(newValue) {
      if (this.showValue == newValue) {
        return
      }
      this.showValue = newValue
    }
  },
  computed: {
    ...mapState(useUserStore, ['country', 'countries'])
  },
  mounted() {
    this.showValue = this.show
  },

  methods: {
    ...mapActions(useUserStore, { updateCountry: 'updateCountry' }),
    onClose() {
      this.$bus.$emit(BUS.SHOW_POPUP, { from: this.from, to: POPUP.SELECT_COUNTRY, show: false })
    },
    onSelect(item) {
      this.updateCountry(item.code)
      this.onClose()
    }
  }
}
</script>

<style lang="scss" scoped>
.popup_box {
  width: 6.5rem;
  height: auto;
  margin: 0 auto;
  padding: 0 !important;
  overflow: visible !important;
  border: solid 0.04rem transparent;
  border-radius: 0.16rem;
  background-color: #f1f1f1;
  // background-image: linear-gradient(#000, #000),
  //   linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
  // background-origin: border-box;
  // background-clip: content-box, border-box;
  text-align: center;
  // overflow: hidden;

  .popup {
    width: 90%;
    height: auto;
    border-radius: 12px;
    display: block;
    padding: 5% 5% 5% 5%;
    margin: 0 auto;
    color: #000;

    h1 {
      font-size: 0.3rem;
      line-height: 0.4rem;
      margin: 0.1rem 0;
      font-weight: normal;
    }

    p {
      line-height: 0.32rem;
      margin: 0;
      color: #000;
    }

    .popup_nation {
      width: 100%;
      overflow: hidden;

      li {
        float: left;
        width: 90%;
        border-radius: 0.16rem;
        display: inline-block;
        line-height: 0.5rem;
        border: 1px solid #95a5a5;
        padding: 3%;
        margin: 0.15rem 0.1rem;

        P {
          float: left;
          color: #95a5a5;
          font-size: 0.24rem;
          margin-left: 0.2rem;
          line-height: 0.75rem;
          font-weight: bold;
          display: inline-block;
        }

        img {
          border-radius: 0.16rem;
          float: left;
          width: 25%;
        }

        i {
          float: right;
          font-size: 0.75rem;
          color: #000;
          display: none;
        }
      }
    }

    .popup_nation_active {
      // border: 2px solid #ffddac !important;
      // box-shadow:
      //   inset 0 0 0.2rem #517ab8,
      //   inset 0 0 0.1rem #517ab8,
      //   inset 0 0 0.05rem #517ab8;
      background-color: #336aea;

      p {
        color: #fff !important;
      }

      i {
        color: #fff !important;
        display: block !important;
      }
    }
  }

  .close_center {
    display: flex !important;
    margin-top: -0.5rem !important;
    justify-content: center;
    align-items: flex-start;
  }

  .popup_close {
    height: 0.8rem;
    width: 0.8rem;
    top: 0.5rem;
    text-align: center;
    position: absolute;
    display: block;
    z-index: 2;
    right: 0rem;

    span {
      display: inline-block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #95a5a5;
      background-image: linear-gradient(130deg, #95a5a5 0%, #95a5a5 100%);
      transform: rotate(45deg);
      margin-top: 0.355rem;
    }

    span::after {
      content: '';
      display: block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #95a5a5;
      background-image: linear-gradient(130deg, #95a5a5 0%, #95a5a5 100%);
      transform: rotate(-90deg);
    }
  }
}
@keyframes scaleIn {
  0% {
    scale: 0;
  }

  100% {
    scale: 1;
  }
}
</style>
